export const REDIRECT_PATH = `/membership/selfservice`;
export const QUERY_PARAM_KEY = 'query_params';
export const PATH_KEY = 'path';
